import { render, staticRenderFns } from "./drawerList.vue?vue&type=template&id=508f4d1f&"
import script from "./drawerList.vue?vue&type=script&lang=js&"
export * from "./drawerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports